import Marquee from "react-fast-marquee";

const ITEMS = ["Dubai", "Bali", "Thailand", "Kashmir", "Kerala", "Singapore", "Goa", "Rajasthan", "1000+ Visas", "Since 2014"];

export const MarqueeStrip = () => (
  <section data-testid="marquee-strip" className="overflow-hidden border-y border-white/10 bg-obsidian py-10">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span
            className="mx-8 whitespace-nowrap font-display text-5xl uppercase tracking-tight text-transparent md:text-7xl"
            style={{ WebkitTextStroke: "1px rgba(255,255,255,0.28)" }}
          >
            {item}
          </span>
          <span className="text-2xl text-sunset">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
